import { ECountry, ELanguage } from '@portals/help-center-core';

type TProps = {
  locale: ELanguage;
  country: ECountry;
  proWbRu: string;
  proWbCn: string;
};

type TNavBarItem = {
  id: string;
  text: string;
  routeName: string;
};

export const getNavBarItems = ({
  locale,
  country,
  proWbRu,
  proWbCn,
}: TProps): Array<TNavBarItem> => [
  {
    id: 'learnInfo',
    text: 'menuItemEducation',
    // тут сами переключаем, потому что в pro.wildberries.ru в исключениях в geo-utils
    routeName: `${
      country === ('cn' as ECountry) ? proWbCn : proWbRu
    }/${locale}/events-calendar`,
  },
];
